import { Helpers } from '../../helpers';
import { IVendor } from '../../interfaces/ivendor';
import { FuelRate } from '../fuel-rate';
import { MudLoggingCost } from '../mud-logging-cost';
import { OpenHoleLoggingCost } from '../open-hole-logging-cost';
import { WellheadCost } from '../wellhead-cost';

export class VendorBase {
  VendorId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FuelRates_Vendor?: Array<FuelRate> | null;
  MudLoggingCosts_Vendor?: Array<MudLoggingCost> | null;
  OpenHoleLoggingCosts_Vendor?: Array<OpenHoleLoggingCost> | null;
  WellheadCosts_Vendor?: Array<WellheadCost> | null;

  constructor(item?: IVendor) {
    if (item) {

      this.VendorId = item.VendorId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FuelRates_Vendor = Helpers.createClassArray(FuelRate, item.FuelRates_Vendor);
      this.MudLoggingCosts_Vendor = Helpers.createClassArray(MudLoggingCost, item.MudLoggingCosts_Vendor);
      this.OpenHoleLoggingCosts_Vendor = Helpers.createClassArray(OpenHoleLoggingCost, item.OpenHoleLoggingCosts_Vendor);
      this.WellheadCosts_Vendor = Helpers.createClassArray(WellheadCost, item.WellheadCosts_Vendor);
    }
  }
}